import { useMutation } from '@apollo/client'
import { LogOut } from '../../types'
import { LOGOUT } from './operations'

export const useLogOutMutation = () => useMutation<LogOut>(LOGOUT)
